import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { withTheme } from '@material-ui/core/styles';
import AppAvatar from '../Avatar/AppAvatar';
import makeStyles from '@material-ui/core/styles/makeStyles';

const settings = (theme) => ({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: theme.breakpoints.values.md,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: theme.breakpoints.values.sm,
      settings: {
        slidesToShow: 2,
        arrows: false,
      },
    },
    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        arrows: false,
        centerMode: true,
        centerPadding: '50px',
      },
    },
  ],
});

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: `calc(100% - ${theme.spacing(2)}px)`,
    height: '100%',
    margin: 'auto',
  },
  wrapper: {
    position: 'relative',
    width: '100%',
    paddingTop: '100%',
  },
  media: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
}));

const PlanImage = ({ src }: { src: string | null }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <AppAvatar src={src} variant="square" className={classes.media} />
      </div>
    </div>
  );
};

class Slick extends React.Component {
  render() {
    const { images, theme } = this.props;

    return (
      <Slider {...settings(theme)} className="service-slick">
        {images.map((url, index) => (
          <PlanImage src={url} key={`plan-image-${index}`} />
        ))}
      </Slider>
    );
  }
}

Slick.defaultProps = {
  images: [],
};

Slick.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
};

export default withTheme(Slick);
